import React, { useEffect, useCallback, useState, useRef} from 'react';
import {useInterval} from "components/hooks/useInterval.js";
import {connect} from 'react-redux';
import {pinAll, getAllHashes} from "decentralized/pinner/pinner.js"

const IPFSDownloader = (props) => { 
    let [hashes, setHashes] = useState([]);
    let pinner = useRef(undefined);
    let [pinned , setPinned] = useState({pinner: 0, pinning: 0, progress: 0});
    useEffect(() => {
        getAllHashes().then(setHashes);
    }, []);

    useEffect(() => {
        if (hashes.length > 0) {
            console.log('hashes  = ', hashes);
            pinner.current = pinAll(hashes);
        }
    }, [hashes]);

    useInterval(() => {
        if (pinner.current) {
            setPinned(pinner.current());
        }
    }, 50);
    
    return (
        <div>
          DOWNLOADER: {hashes.length} total hashes (pinned {pinned.pinned} pinning {pinned.pinning}) Progress={pinned.progress}%

        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IPFSDownloader);
